import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-16 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-189">
      <div className="max-w-2xl mx-auto text-center" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#070B16] p-8 md:p-12 rounded-2xl border border-[#F6C65B]/30 shadow-[0_0_20px_rgba(246,198,91,0.1)]" data-id="element-191">
          <div className="w-16 h-16 bg-[#F6C65B]/10 rounded-full flex items-center justify-center mx-auto mb-6 border border-[#F6C65B]/30" data-id="element-192">
            <span className="text-[#F6C65B] text-3xl" data-id="element-193">🛡️</span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-194">
            Pruébalo sin presión durante 7 días
          </h2>

          <div className="text-gray-300 space-y-4 text-lg" data-id="element-195">
            <p data-id="element-196">Entra.</p>
            <p data-id="element-197">Revisa el protocolo.</p>
            <p data-id="element-198">Haz la rutina.</p>
            <p data-id="element-199">
              Si sientes que no es para ti, escribes dentro de los primeros 7
              días y te devolvemos tu dinero.
            </p>
            <p data-id="element-200">Sin preguntas incómodas.</p>
            <p className="text-white font-medium" data-id="element-201">
              El riesgo lo asumimos nosotros.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}